const getFieldCSSClasses = (touched: any, errors: any) => {
    const classes = ['form-control']
    /*if (touched && errors) {
      classes.push('is-invalid')
    }
  
    if (touched && !errors) {
      classes.push('is-valid')
    }*/

    return classes.join(' ')
}

export function CustomInput({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    label,
    icon,
    type = 'text',
    extraText,
    className,
    ...props
}: any) {
    return (
        <div className="input-with-icon">
            {label && <label className={extraText && 'mb-0'}>Enter {label}</label>}
            {extraText && <p className="text-muted font-weight-light">{extraText}</p>}
            <input
                type={type}
                {...field}
                {...props}
                className={`${getFieldCSSClasses(touched[field.name], errors[field.name])} ${className} form-control`}
            />
            {icon && <span className="input-icon">{icon}</span>}
        </div>
    )
}